export default "__VITE_ASSET__0c8361ec__"